import { render } from "./ChapterView.vue?vue&type=template&id=45145dc4&scoped=true"
import script from "./ChapterView.vue?vue&type=script&lang=js"
export * from "./ChapterView.vue?vue&type=script&lang=js"

import "./ChapterView.vue?vue&type=style&index=0&id=45145dc4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45145dc4"]])

export default __exports__